import React from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@/components/DataTable";
import { CustomFilterTable } from "@/components/DataTable/Header/Filter";

interface TableHeaderProps {
  onFilterChange: (filterId: string, values: string[]) => void;
  filterDisplayValue: string | undefined;
  customFilters: CustomFilterTable[];
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  onFilterChange,
  filterDisplayValue,
  customFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-start justify-between p-6 pr-0">
      <DataTable.Title
        title={t(
          "bulkMessaging.communityToolsOverview.tabs.bulkMessages.title",
        )}
        description={t(
          "bulkMessaging.communityToolsOverview.tabs.bulkMessages.subtitle",
        )}
        className="p-0"
      />
      <div className="flex flex-shrink-0 gap-2">
        <DataTable.Filter
          customFilters={customFilters}
          onFilterChange={onFilterChange}
          displayValue={filterDisplayValue}
        />
        <DataTable.HeaderActions
          actions={
            [
              /* Disable for now
            {
              key: "export-csv",
              render: () => (
                <>
                  <FileDown
                    className="mr-2 h-4 w-4"
                    aria-label={t(
                      "bulkMessaging.communityToolsOverview.actions.exportCsv",
                    )}
                  />
                  {t("bulkMessaging.communityToolsOverview.actions.exportCsv")}
                </>
              ),
              onClick: () => {
                console.log("Implement CSV export");
              },
            },
            */
            ]
          }
        />
      </div>
    </div>
  );
};
